// its middlewear to handle reducer call to update a state

import { getData } from "../../../backend/api";

const fetchLanguages = () => {
  return (dispatch) => {
    dispatch({
      type: "FETCH_LANGUAGE_LOADING",
    });
    getData({}, "language/select")
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: "FETCH_LANGUAGE_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "FETCH_LANGUAGE_ERROR",
            payload: "validationFailed",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "FETCH_LANGUAGE_ERROR",
          payload: "validationFailed",
        });
      });
  };
};
export { fetchLanguages };
